import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useErrorToast } from './queryUtils';
import {
  listPersonalApiTokens,
  createPersonalApiToken,
  revokePersonalApiToken,
  type CreateTokenInput,
} from '../services/api/personalApiTokens';

const PERSONAL_API_TOKENS_KEY = ['personal-api-tokens'];

export function usePersonalApiTokens() {
  return useQuery({
    queryKey: PERSONAL_API_TOKENS_KEY,
    queryFn: listPersonalApiTokens,
  });
}

export function useCreatePersonalApiToken() {
  const queryClient = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: (input: CreateTokenInput) => createPersonalApiToken(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PERSONAL_API_TOKENS_KEY });
    },
    onError: (err) => onError(err, "Couldn't create token"),
  });
}

export function useRevokePersonalApiToken() {
  const queryClient = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: (id: number) => revokePersonalApiToken(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PERSONAL_API_TOKENS_KEY });
    },
    onError: (err) => onError(err, "Couldn't revoke token"),
  });
}
